export { default } from "../../../../../../components/FormatByOperatingLocation";
